class QuantitySelectorInfo extends HTMLElement {
  constructor() {
    super();
    this.options = this.querySelectorAll('.et-quantity-selector-info__option');
    this.hiddenInput = this.querySelector('input[type="hidden"]');
    
    this.init();
  }

  init() {
    this.options.forEach(option => {
      option.addEventListener('click', this.handleOptionClick.bind(this));
    });
  }

  handleOptionClick(event) {
    const clickedOption = event.currentTarget;
    const quantity = clickedOption.dataset.quantity;
    
    this.options.forEach(opt => {
      opt.classList.remove('et-quantity-selector-info__option--selected');
    });
    
    clickedOption.classList.add('et-quantity-selector-info__option--selected');
    
    if (this.hiddenInput && quantity) {
      this.hiddenInput.value = quantity;
      
      const quantityInput = document.querySelector(`#Quantity-${this.hiddenInput.id.split('-').pop()}`);
      if (quantityInput) {
        quantityInput.value = quantity;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
}

if (!customElements.get('et-quantity-selector-info')) {
  customElements.define('et-quantity-selector-info', QuantitySelectorInfo);
}
